var makeObject = {
  "AM General": {
    "Hummer": ["2001"]
  },
  "Acura": {
    "CL": ["2003", "2002", "2001", "1999", "1998", "1997"],
    "CSX": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "EL": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "ILX": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Integra": ["2025", "2024", "2023", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Legend": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "MDX": ["2025", "2024", "2023", "2022", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "NSX": ["2022", "2021", "2020", "2019", "2018", "2017", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "RDX": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "RL": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "RLX": ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "RSX": ["2006", "2005", "2004", "2003", "2002"],
    "SLX": ["1999", "1998", "1997", "1996"],
    "TL": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "TLX": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "TSX": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Vigor": ["1994", "1993", "1992"],
    "ZDX": ["2025", "2024", "2013", "2012", "2011", "2010"]
  },
  "Alfa Romeo": {
    "4C": ["2020", "2019", "2018", "2017", "2016", "2015"],
    "Giulia": ["2020", "2019", "2018", "2017"],
    "Mito": ["2016", "2015", "2013"],
    "Stelvio": ["2022", "2021", "2020", "2019", "2018"],
    "Tonale": ["2024"]
  },
  "Aston Martin": {
    "Lagonda": ["1985"]
  },
  "Asuna": {
    "Sunfire": ["1993"],
    "Sunrunner": ["1993", "1992"]
  },
  "Audi": {
    "100": ["1994", "1993", "1992", "1991", "1990", "1989"],
    "100 Quattro": ["1994", "1993", "1992", "1991", "1990", "1989"],
    "100 Series": ["1977", "1976", "1975"],
    "200": ["1991", "1990", "1989"],
    "200 Quattro": ["1991", "1990", "1989"],
    "4000": ["1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980"],
    "4000 Quattro": ["1987", "1986", "1985", "1984"],
    "5000": ["1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "5000 Quattro": ["1988", "1987", "1986"],
    "80": ["1992", "1991", "1990", "1989", "1988"],
    "80 Quattro": ["1992", "1991", "1990", "1989", "1988"],
    "90": ["1995", "1994", "1993", "1991", "1990", "1989", "1988"],
    "90 Quattro": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "A1": ["2023", "2022", "2021", "2020", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "A3": ["2024", "2023", "2022", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "A3 Quattro": ["2024", "2023", "2022", "2020", "2019", "2018", "2017", "2016", "2015", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "A3 Sportback e-tron": ["2018", "2017", "2016"],
    "A3 e-tron": ["2016"],
    "A4": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "A4 Quattro": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "A4 allroad": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "A5": ["2024", "2023", "2022", "2021", "2019", "2018", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "A5 Quattro": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "A5 Sportback": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "A6": ["2023", "2022", "2021", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "A6 Quattro": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "A6 allroad": ["2024", "2023", "2022", "2021", "2020"],
    "A7": ["2018", "2017", "2016"],
    "A7 Quattro": ["2020", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "A7 Sportback": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "A8": ["2016", "2000", "1999", "1998", "1997"],
    "A8 Quattro": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Allroad Quattro": ["2005", "2004", "2003", "2002", "2001"],
    "Cabriolet": ["1998", "1997", "1996", "1995", "1994"],
    "Coupe": ["1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "Coupe Quattro": ["1991", "1990"],
    "Fox": ["1979", "1978", "1977", "1976", "1975"],
    "Q2": ["2023", "2022", "2021", "2020", "2019", "2018"],
    "Q2 Quattro": ["2020", "2019", "2018"],
    "Q3": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Q3 Quattro": ["2018", "2017", "2016", "2015", "2014", "2013"],
    "Q4 e-tron": ["2024", "2023", "2022"],
    "Q4 e-tron Sportback": ["2024", "2023", "2022"],
    "Q5": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Q5 PHEV": ["2024", "2023", "2022", "2021", "2020"],
    "Q5 Sportback": ["2024", "2023", "2022", "2021"],
    "Q7": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Q8": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "Q8 e-tron": ["2024"],
    "Q8 e-tron Sportback": ["2024"],
    "Quattro": ["1986", "1985", "1984", "1983"],
    "R8": ["2023", "2022", "2021", "2020", "2018", "2017", "2016", "2015", "2014", "2012", "2011", "2010", "2009", "2008"],
    "RS Q3": ["2022", "2021", "2018", "2017"],
    "RS Q8": ["2023", "2022", "2021", "2020"],
    "RS e-tron GT": ["2023", "2022"],
    "RS3": ["2024", "2023", "2022", "2020", "2019", "2018", "2017"],
    "RS4": ["2008", "2007", "2002"],
    "RS5": ["2024", "2023", "2022", "2021", "2019", "2018", "2016", "2015", "2014", "2013", "2011"],
    "RS5 Sportback": ["2024", "2023", "2022", "2021", "2019"],
    "RS6": ["2010", "2004", "2003"],
    "RS6 Avant": ["2024", "2023", "2022", "2021"],
    "RS7": ["2018", "2017", "2016", "2015", "2014"],
    "RS7 Sportback": ["2024", "2023", "2022", "2021"],
    "S3": ["2024", "2023", "2022", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2012", "2011", "2010", "2009", "2008", "2004", "2003", "2002", "2001", "2000"],
    "S4": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2002", "2001", "2000", "1994", "1993", "1992"],
    "S5": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "S5 Sportback": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "S6": ["2024", "2023", "2022", "2021", "2020", "2018", "2017", "2016", "2015", "2014", "2013", "2011", "2010", "2009", "2008", "2007", "2004", "2003", "2002", "2001", "1997", "1996", "1995"],
    "S7": ["2020", "2018", "2017", "2016", "2015", "2014", "2013"],
    "S7 Sportback": ["2024", "2023", "2022", "2021", "2020"],
    "S8": ["2024", "2023", "2022", "2021", "2020", "2018", "2017", "2016", "2015", "2014", "2013", "2010", "2009", "2008", "2007", "2003", "2002", "2001"],
    "SQ5": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "SQ5 Sportback": ["2024", "2023", "2022", "2021"],
    "SQ7": ["2024", "2023", "2022", "2021", "2020"],
    "SQ8": ["2024", "2023", "2022", "2021", "2020"],
    "SQ8 e-tron": ["2024"],
    "SQ8 e-tron Sportback": ["2024"],
    "TT": ["2018", "2017", "2016", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "TT Quattro": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "TT RS": ["2014", "2013", "2012", "2011"],
    "TT RS Quattro": ["2022", "2021", "2020", "2019", "2018", "2014", "2013", "2012", "2011"],
    "TTS": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "TTS Quattro": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "V8 Quattro": ["1994", "1993", "1992", "1991", "1990"],
    "allroad": ["2016", "2015", "2014", "2013"],
    "e-tron GT": ["2024", "2023", "2022"],
    "e-tron Quattro": ["2023", "2022", "2021", "2020", "2019"],
    "e-tron S": ["2023", "2022"],
    "e-tron S Sportback": ["2023", "2022"],
    "e-tron Sportback": ["2023", "2022", "2021", "2020"]
  },
  "Autocar LLC.": {
    "Xspotter On Road": ["2019"]
  },
  "BMW": {
    "1 Series M": ["2011"],
    "118i": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2015", "2014", "2013", "2012"],
    "120i": ["2021", "2020", "2019", "2018", "2017", "2016", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "125i": ["2013", "2012", "2011", "2010", "2009", "2008"],
    "128i": ["2013", "2012", "2011", "2010", "2009", "2008"],
    "128ti": ["2024", "2023", "2022"],
    "130i": ["2010", "2009", "2008", "2007", "2006"],
    "135i": ["2013", "2012", "2011", "2010", "2009", "2008"],
    "135is": ["2013"],
    "1500": ["1962"],
    "1600": ["1966", "1964"],
    "1600-2": ["1971", "1970", "1969", "1968", "1967", "1966"],
    "1600ti": ["1967", "1966"],
    "1602": ["1967"],
    "1800": ["1963"],
    "1800ti": ["1964"],
    "1802": ["1971"],
    "2000": ["1972", "1971", "1970", "1969", "1968", "1967", "1966"],
    "2000c": ["1966"],
    "2000cs": ["1966", "1965"],
    "2000ti": ["1966"],
    "2000tii": ["1970"],
    "2002": ["1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966"],
    "2002ti": ["1968"],
    "2002tii": ["1971"],
    "220i": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "220i Gran Coupe": ["2024", "2023", "2022"],
    "228 xDrive Gran Coupe": ["2025"],
    "228i": ["2016", "2015", "2014"],
    "228i Gran Coupe": ["2024", "2023", "2022", "2021"],
    "228i xDrive": ["2016", "2015"],
    "228i xDrive Gran Coupe": ["2024", "2023", "2022", "2021", "2020"],
    "230i": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "230i xDrive": ["2025", "2024", "2023", "2021", "2020", "2019", "2018", "2017"],
    "235i": ["2014"],
    "2500": ["1971", "1970", "1969", "1968"],
    "2800": ["1969"],
    "2800CS": ["1968"],
    "3.0CS": ["1971"],
    "3.0CSL": ["1971"],
    "3.0CSi": ["1972", "1971"],
    "3.0S": ["1971"],
    "3.0Si": ["1976", "1975", "1971"],
    "318i": ["2018", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1985", "1984"],
    "318is": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "318ti": ["1999", "1998", "1997", "1996", "1995"],
    "320i": ["2025", "2024", "2023", "2022", "2021", "2020", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2005", "2004", "2003", "2002", "2001", "1995", "1994", "1993", "1992", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "320i xDrive": ["2018", "2017", "2016", "2015", "2014", "2013"],
    "323Ci": ["2000"],
    "323i": ["2011", "2010", "2009", "2008", "2007", "2006", "2001", "2000", "1999", "1998", "1997"],
    "323is": ["1999", "1998"],
    "323ti": ["2000", "1999"],
    "325": ["1988", "1987", "1986"],
    "325Ci": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "325e": ["1987", "1986", "1985", "1984"],
    "325es": ["1987", "1986"],
    "325i": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "325iX": ["1991", "1990", "1989", "1988"],
    "325is": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "325xi": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "326": ["1941", "1940", "1939", "1938", "1937"],
    "327": ["1941", "1940", "1939", "1938", "1937"],
    "328": ["1939", "1938", "1937"],
    "328Ci": ["2000"],
    "328d": ["2018", "2017", "2016", "2015", "2014"],
    "328d xDrive": ["2018", "2017", "2016", "2015", "2014"],
    "328i": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2000", "1999", "1998", "1997", "1996"],
    "328i GT xDrive": ["2016", "2015", "2014"],
    "328i xDrive": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "328is": ["1999", "1998", "1997", "1996"],
    "328xi": ["2008", "2007"],
    "330Ci": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "330e": ["2025", "2024", "2023", "2022", "2021", "2020", "2018", "2017", "2016"],
    "330e xDrive": ["2024", "2023", "2022", "2021"],
    "330i": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "330i GT xDrive": ["2019", "2018", "2017"],
    "330i xDrive": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "330xi": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "335": ["1940", "1939"],
    "335d": ["2011", "2010", "2009"],
    "335i": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "335i GT xDrive": ["2016", "2015", "2014"],
    "335i xDrive": ["2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "335is": ["2013", "2012", "2011"],
    "335xi": ["2008", "2007"],
    "340i": ["2018", "2017", "2016"],
    "340i GT xDrive": ["2019", "2018", "2017"],
    "340i xDrive": ["2018", "2017", "2016"],
    "420i": ["2020", "2019", "2018", "2017", "2016"],
    "420i Gran Coupe": ["2021", "2020", "2019", "2018", "2016"],
    "428i": ["2016", "2015", "2014"],
    "428i Gran Coupe": ["2016", "2015"],
    "428i xDrive": ["2016", "2015", "2014"],
    "428i xDrive Gran Coupe": ["2016", "2015"],
    "430i": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "430i Gran Coupe": ["2025", "2024", "2023", "2022", "2020", "2019", "2018", "2017"],
    "430i xDrive": ["2026", "2025", "2024", "2023", "2022", "2020", "2019", "2018", "2017"],
    "430i xDrive Gran Coupe": ["2025", "2020", "2019", "2018", "2017"],
    "435i": ["2016", "2015", "2014"],
    "435i Gran Coupe": ["2016", "2015"],
    "435i xDrive": ["2016", "2015", "2014"],
    "435i xDrive Gran Coupe": ["2016", "2015"],
    "440i": ["2020", "2019", "2018", "2017"],
    "440i Gran Coupe": ["2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "440i xDrive": ["2020", "2019", "2018", "2017"],
    "440i xDrive Gran Coupe": ["2020", "2019", "2018", "2017"],
    "520i": ["2020", "2019", "2018", "2016", "2015", "2014"],
    "524td": ["1986", "1985"],
    "525i": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "525iT": ["1993"],
    "525xi": ["2007", "2006"],
    "528e": ["1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "528i": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2000", "1999", "1998", "1997", "1996", "1981", "1980", "1979"],
    "528i xDrive": ["2016", "2015", "2014", "2013", "2012", "2010", "2009"],
    "528xi": ["2008"],
    "530e": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "530e xDrive": ["2023", "2022", "2021", "2020", "2019", "2018"],
    "530e xDrive iPerformance": ["2018"],
    "530i": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2013", "2012", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "1995", "1994", "1978", "1977", "1976", "1975"],
    "530i xDrive": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "530xi": ["2007", "2006"],
    "533i": ["1984", "1983"],
    "535d": ["2016", "2015", "2014"],
    "535d xDrive": ["2016", "2015", "2014"],
    "535i": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "535i GT": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "535i GT xDrive": ["2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "535i xDrive": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "535is": ["1988"],
    "535xi": ["2008"],
    "540d xDrive": ["2018"],
    "540i": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1995", "1994"],
    "540i xDrive": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "545i": ["2006", "2005", "2004"],
    "550e xDrive": ["2026", "2025"],
    "550i": ["2022", "2021", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "550i GT": ["2015", "2014", "2013", "2012", "2011", "2010"],
    "550i GT xDrive": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "550i xDrive": ["2018", "2016", "2015", "2014", "2013", "2012", "2011"],
    "630CSi": ["1978", "1977"],
    "633CSi": ["1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "635CSi": ["1989", "1988", "1987", "1986", "1985"],
    "640i": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "640i Gran Coupe": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "640i xDrive": ["2018", "2017", "2016", "2015", "2014"],
    "640i xDrive Gran Coupe": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "640i xDrive Gran Turismo": ["2019", "2018"],
    "645Ci": ["2005", "2004"],
    "650Ci": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "650i": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2010", "2009", "2008", "2007", "2006"],
    "650i Gran Coupe": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "650i xDrive": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "650i xDrive Gran Coupe": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "733i": ["1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "735i": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "735iL": ["1992", "1991", "1990", "1989", "1988"],
    "740Ld xDrive": ["2015"],
    "740Le xDrive": ["2017"],
    "740Li": ["2015", "2014", "2013", "2012", "2011"],
    "740Li xDrive": ["2015", "2014", "2013"],
    "740e xDrive": ["2019", "2018", "2017"],
    "740i": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2001", "2000", "1999", "1998", "1997", "1995", "1994", "1993"],
    "740i xDrive": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "740iL": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "745Le xDrive": ["2022", "2021", "2020"],
    "745Li": ["2005", "2004", "2003", "2002"],
    "745e": ["2022", "2021", "2020"],
    "745e xDrive": ["2022", "2021", "2020"],
    "745i": ["2005", "2004", "2003", "2002"],
    "750Li": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "750Li xDrive": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "750e xDrive": ["2025", "2024"],
    "750i": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "750i xDrive": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "750iL": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "760Li": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "760i": ["2006", "2005", "2004"],
    "760i xDrive": ["2025", "2024", "2023"],
    "840Ci": ["1997", "1996", "1995", "1994"],
    "840i": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "840i Gran Coupe": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "840i xDrive": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "840i xDrive Gran Coupe": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "850CSi": ["1995", "1994"],
    "850Ci": ["1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "850i": ["1992", "1991"],
    "ActiveHybrid 3": ["2015", "2014", "2013"],
    "ActiveHybrid 5": ["2016", "2015", "2014", "2013", "2012"],
    "ActiveHybrid 7": ["2015", "2014", "2013"],
    "Alpina B6 Gran Coupe": ["2016"],
    "Alpina B6 xDrive Gran Coupe": ["2019", "2018", "2017", "2016", "2015"],
    "Alpina B7": ["2022", "2021", "2020", "2019", "2018", "2017", "2015", "2014", "2013", "2012", "2011", "2008", "2007"],
    "Alpina B7 xDrive": ["2015", "2014", "2013", "2012", "2011"],
    "Alpina B7L": ["2015", "2014", "2013", "2012", "2011"],
    "Alpina B7L xDrive": ["2015", "2014", "2013", "2012", "2011"],
    "Alpina B8 Gran Coupe": ["2025", "2024", "2023", "2022"],
    "Alpina XB7": ["2024", "2023", "2022", "2021"],
    "Isetta": ["1965", "1964", "1963", "1962", "1961", "1960", "1959", "1958", "1957", "1956", "1955"],
    "L6": ["1987"],
    "L7": ["1987", "1986"],
    "M135i": ["2025", "2024", "2023", "2022", "2021", "2020", "2016", "2015", "2014", "2013"],
    "M140i": ["2019", "2018", "2017"],
    "M2": ["2025", "2024", "2023", "2021", "2020", "2019", "2018", "2017", "2016"],
    "M235 xDrive Gran Coupe": ["2025"],
    "M235i": ["2016", "2015", "2014"],
    "M235i xDrive": ["2020", "2016", "2015"],
    "M235i xDrive Gran Coupe": ["2024", "2023", "2022", "2021", "2020"],
    "M240i": ["2025", "2024", "2023", "2021", "2020", "2019", "2018", "2017"],
    "M240i xDrive": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "M3": ["2025", "2024", "2023", "2022", "2021", "2018", "2017", "2016", "2015", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004", "2003", "2002", "2001", "1999", "1998", "1997", "1996", "1995", "1994", "1991", "1990", "1989", "1988"],
    "M340i": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "M340i xDrive": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "M4": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "M440i": ["2025", "2024", "2023", "2022", "2021"],
    "M440i Gran Coupe": ["2025", "2024", "2023", "2022"],
    "M440i xDrive": ["2026", "2025", "2024", "2023", "2022", "2021"],
    "M440i xDrive Gran Coupe": ["2025", "2024", "2023", "2022"],
    "M5": ["2026", "2025", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2010", "2009", "2008", "2007", "2006", "2003", "2002", "2001", "2000", "1999", "1993", "1992", "1991", "1988"],
    "M5 Touring": ["2026", "2025"],
    "M550i xDrive": ["2023", "2022", "2021", "2020", "2019", "2018"],
    "M6": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "1988", "1987"],
    "M6 Gran Coupe": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "M760Li xDrive": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "M760i xDrive": ["2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "M8": ["2025", "2024", "2023", "2022", "2020"],
    "M8 Gran Coupe": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "M850i xDrive": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "M850i xDrive Gran Coupe": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "X1": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "X2": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "X3": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "X4": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "X5": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "X6": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "X7": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "XM": ["2025", "2024", "2023"],
    "Z3": ["2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Z4": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Z8": ["2003", "2002", "2001", "2000"],
    "i3": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "i3s": ["2022", "2021", "2020", "2019", "2018"],
    "i4": ["2025", "2024", "2023", "2022"],
    "i5": ["2025", "2024"],
    "i7": ["2025", "2024", "2023"],
    "i8": ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "iX": ["2025", "2024", "2023", "2022"],
    "iX xDrive40": ["2023", "2022"],
    "iX xDrive50": ["2023", "2022"],
    "iX1": ["2025", "2024"],
    "iX2": ["2025", "2024"],
    "iX3": ["2025", "2024", "2022", "2021"]
  },
  "Bricklin": {
    "SV-1": ["1975"]
  },
  "BrightDrop": {
    "Zevo": ["2024"]
  },
  "Buick": {
    "Allure": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Cascada": ["2019", "2018", "2017", "2016"],
    "Century": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Commercial Chassis": ["1996", "1995", "1994", "1993", "1992", "1991"],
    "Electra": ["1990", "1989", "1988", "1987", "1986", "1985", "1984", "1970"],
    "Enclave": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Encore": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Encore GX": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "Envision": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Envista": ["2026", "2025", "2024"],
    "Estate Wagon": ["1975"],
    "LaCrosse": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "LeSabre": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1976", "1975"],
    "Lucerne": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "Park Avenue": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "Rainier": ["2007", "2006", "2005", "2004"],
    "Reatta": ["1991", "1990", "1989", "1988"],
    "Regal": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "Regal Sportback": ["2020", "2019", "2018"],
    "Regal TourX": ["2020", "2019", "2018"],
    "Rendezvous": ["2007", "2006", "2005", "2004", "2003", "2002"],
    "Riviera": ["1999", "1998", "1997", "1996", "1995", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1985", "1971", "1970"],
    "Roadmaster": ["1996", "1995", "1994", "1993", "1992", "1991"],
    "Skyhawk": ["1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Skylark": ["1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Somerset": ["1987", "1986"],
    "Somerset Regal": ["1985"],
    "Terraza": ["2007", "2006", "2005"],
    "Verano": ["2017", "2016", "2015", "2014", "2013", "2012"]
  },
  "Cadillac": {
    "60 Special": ["1993"],
    "ATS": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Allante": ["1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Brougham": ["1992", "1991", "1990", "1989", "1988", "1987"],
    "CELESTIQ": ["2025"],
    "CT4": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "CT5": ["2026", "2025", "2024", "2023", "2022", "2021", "2020"],
    "CT6": ["2020", "2019", "2018", "2017", "2016"],
    "CTS": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Catera": ["2001", "2000", "1999", "1998", "1997"],
    "Cimarron": ["1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Commercial Chassis": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "DTS": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "DeVille": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "ELR": ["2016", "2015", "2014"],
    "ESCALADE IQ": ["2026", "2025"],
    "ESCALADE IQL": ["2026"],
    "Eldorado": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Escalade": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2000", "1999"],
    "Escalade ESV": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Escalade EXT": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Fleetwood": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "LYRIQ": ["2026", "2025", "2024", "2023"],
    "OPTIQ": ["2026", "2025"],
    "SRX": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "STS": ["2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Seville": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "VISTIQ": ["2026"],
    "XLR": ["2009", "2008", "2007", "2006", "2005", "2004"],
    "XT4": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "XT5": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "XT6": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "XTS": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"]
  },
  "Chevrolet": {
    "Astro": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Avalanche": ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Avalanche 1500": ["2006", "2005", "2004", "2003", "2002"],
    "Avalanche 2500": ["2006", "2005", "2004", "2003", "2002"],
    "Aveo": ["2022", "2021", "2020", "2019", "2018", "2017", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Aveo5": ["2011", "2010", "2009", "2008", "2007"],
    "B60": ["1989", "1985", "1984", "1983", "1982", "1981"],
    "B7": ["2000", "1999"],
    "Beat": ["2021", "2020", "2019", "2018"],
    "Bel Air": ["1975", "1973", "1971"],
    "Beretta": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Biscayne": ["1970"],
    "Blazer": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1973"],
    "Blazer EV": ["2026", "2025", "2024"],
    "Bolt EUV": ["2023", "2022"],
    "Bolt EV": ["2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "BrightDrop 400": ["2025"],
    "BrightDrop 600": ["2025"],
    "C10": ["1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "C10 Suburban": ["1986", "1985", "1984", "1983"],
    "C1500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "C1500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "C20": ["1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "C20 Suburban": ["1986", "1985", "1984", "1983", "1982", "1981"],
    "C2500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "C2500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "C30": ["1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "C3500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "C3500HD": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "C4500 Kodiak": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "C5500 Kodiak": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "C60": ["1987", "1986", "1985", "1984", "1980"],
    "C6500 Kodiak": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "C70": ["1980"],
    "C7500 Kodiak": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "C8500": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Camaro": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967"],
    "Caprice": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1982", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1970"],
    "Captiva": ["2022"],
    "Captiva Sport": ["2015", "2014", "2013", "2012"],
    "Cavalier": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Celebrity": ["1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Chevelle": ["1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964"],
    "Chevette": ["1987", "1986", "1985", "1984"],
    "Chevy II": ["1967", "1966", "1965", "1964", "1963", "1962"],
    "Cheyenne": ["2021", "2020", "2019", "2018", "2017"],
    "Citation II": ["1985", "1984"],
    "City Express": ["2018", "2017", "2016", "2015"],
    "Classic": ["2005", "2004"],
    "Cobalt": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Colorado": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Commercial Chassis": ["1994", "1993", "1992", "1991"],
    "Corsica": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Corvette": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968"],
    "Cruze": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Cruze Limited": ["2016"],
    "El Camino": ["1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964", "1960", "1959"],
    "Epica": ["2006", "2005", "2004"],
    "Equinox": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Equinox EV": ["2026", "2025", "2024"],
    "Express 1500": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Express 2500": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Express 3500": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Express 4500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Express Cargo": ["2021", "2020", "2019", "2018", "2017", "2013", "2012", "2011", "2010"],
    "Express Pasajeros": ["2021", "2020", "2019", "2018", "2017", "2014", "2013", "2012", "2011", "2010"],
    "G10": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1981"],
    "G20": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "G30": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "HHR": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "Impala": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1996", "1995", "1994", "1985", "1984", "1979", "1978", "1977", "1976", "1975", "1972", "1971", "1970"],
    "Impala Limited": ["2016", "2015", "2014"],
    "K10": ["1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "K10 Suburban": ["1986", "1985", "1984"],
    "K1500": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "K1500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "K20": ["1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "K20 Suburban": ["1986", "1985", "1984", "1983", "1982", "1981", "1973"],
    "K2500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "K2500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "K30": ["1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "K3500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "K5 Blazer": ["1986", "1985", "1984", "1983", "1982"],
    "LCF 3500": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "LCF 3500HD": ["2017"],
    "LCF 3500HG": ["2026", "2025", "2024"],
    "LCF 4500": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "LCF 4500HD": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "LCF 4500XD": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "LCF 5500HD": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "LCF 5500HG": ["2025", "2024"],
    "LCF 5500XD": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "LCF 5500XG": ["2025", "2024"],
    "LCF 6500XD": ["2021", "2020", "2019", "2018"],
    "LLV": ["1995", "1994"],
    "LUV": ["1979"],
    "Lumina": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Lumina APV": ["1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Lumina Van": ["1995"],
    "Malibu": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1983", "1982", "1981", "1980", "1979", "1978"],
    "Malibu Limited": ["2016"],
    "Metro": ["1998", "1992"],
    "Monte Carlo": ["2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1973", "1972", "1970"],
    "Nova": ["1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969"],
    "Nuevo Aveo": ["2018"],
    "Onix": ["2021"],
    "Optra": ["2007", "2006", "2005", "2004"],
    "Orlando": ["2014", "2013", "2012"],
    "P20": ["1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "P30": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Prizm": ["2002", "2001", "2000", "1999", "1998"],
    "R10": ["1987"],
    "R10 Suburban": ["1988", "1987"],
    "R1500 Suburban": ["1991", "1990", "1989"],
    "R20": ["1988", "1987"],
    "R20 Suburban": ["1988", "1987"],
    "R2500": ["1989"],
    "R2500 Suburban": ["1991", "1990", "1989"],
    "R30": ["1988", "1987"],
    "R3500": ["1991", "1990", "1989"],
    "S10": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "S10 Blazer": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "SS": ["2017", "2016", "2015", "2014"],
    "SSR": ["2006", "2005", "2004", "2003"],
    "Silverado": ["1999", "1998"],
    "Silverado 1500": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Silverado 1500 Classic": ["2007"],
    "Silverado 1500 HD": ["2006", "2005", "2003", "2002", "2001"],
    "Silverado 1500 HD Classic": ["2007"],
    "Silverado 1500 LD": ["2019"],
    "Silverado 1500 LTD": ["2022"],
    "Silverado 1500 Nueva": ["2022"],
    "Silverado 2500": ["2017", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Silverado 2500 HD": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Silverado 2500 HD Classic": ["2007"],
    "Silverado 3500": ["2018", "2017", "2016", "2015", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Silverado 3500 Classic": ["2007"],
    "Silverado 3500 HD": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Silverado 4500 HD": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "Silverado 5500 HD": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "Silverado 6500 HD": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "Silverado EV": ["2026", "2025", "2024"],
    "Sonic": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Spark": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Spark Classic": ["2017"],
    "Spark EV": ["2016", "2015", "2014"],
    "Spectrum": ["1986"],
    "Sprint": ["1992", "1991", "1990", "1989", "1988", "1987"],
    "Suburban": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1959", "1958", "1957", "1956", "1955", "1954", "1953", "1952", "1951", "1950", "1949", "1948", "1947"],
    "Suburban 1500": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1998", "1997", "1996", "1995"],
    "Suburban 2500": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Suburban 3500 HD": ["2019", "2018", "2017", "2016"],
    "T6500": ["2009", "2008", "2007", "2006", "2005", "2004", "1998", "1997"],
    "T7500": ["2009", "2008", "2007", "2006", "2005", "2004", "1998", "1997"],
    "T8500": ["2007", "2006", "2005", "2004"],
    "Tahoe": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Tornado": ["2020", "2019", "2018", "2017"],
    "Tracker": ["2022", "2021", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1991", "1990", "1989"],
    "Trailblazer": ["2026", "2025", "2024", "2023", "2022", "2021", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Trailblazer EXT": ["2006", "2005", "2004", "2003", "2002"],
    "Traverse": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Traverse Limited": ["2024"],
    "Trax": ["2026", "2025", "2024", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Uplander": ["2009", "2008", "2007", "2006", "2005"],
    "V10": ["1987"],
    "V10 Suburban": ["1988", "1987"],
    "V1500 Suburban": ["1991", "1990", "1989"],
    "V20": ["1987"],
    "V20 Suburban": ["1988", "1987"],
    "V2500 Suburban": ["1991", "1990", "1989"],
    "V30": ["1988", "1987"],
    "V3500": ["1991", "1990", "1989"],
    "Venture": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Volt": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"]
  },
  "Chrysler": {
    "200": ["2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "300": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "300M": ["2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "Aspen": ["2009", "2008", "2007"],
    "Cirrus": ["2010", "2009", "2008", "2007", "2006", "2005", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Concorde": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Conquest": ["1989", "1988", "1987"],
    "Crossfire": ["2008", "2007", "2006", "2005", "2004"],
    "Daytona": ["1990", "1989", "1988", "1987", "1986", "1985"],
    "Dynasty": ["1990", "1989", "1988"],
    "E Class": ["1984"],
    "Executive Limousine": ["1986", "1985"],
    "Executive Sedan": ["1984"],
    "Fifth Avenue": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "Grand Voyager": ["2000"],
    "Imperial": ["1993", "1992", "1991", "1990"],
    "Intrepid": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1994", "1993"],
    "LHS": ["2001", "2000", "1999", "1997", "1996", "1995", "1994"],
    "Laser": ["1986", "1985", "1984"],
    "LeBaron": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Neon": ["2002", "2001", "2000"],
    "New Yorker": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "PT Cruiser": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Pacifica": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2008", "2007", "2006", "2005", "2004"],
    "Prowler": ["2002", "2001"],
    "Sebring": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "TC Maserati": ["1991", "1990", "1989"],
    "Town & Country": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1988", "1987", "1986", "1985", "1984"],
    "Voyager": ["2024", "2023", "2022", "2021", "2020", "2003", "2002", "2001", "2000"]
  },
  "Daewoo": {
    "Nubira": ["2002", "2001", "2000", "1999"]
  },
  "Datsun": {
    "200SX": ["1983", "1982", "1981", "1980", "1979"],
    "260Z": ["1975", "1974"],
    "280Z": ["1978", "1977", "1976", "1975"],
    "280ZX": ["1983", "1982", "1981", "1980", "1979"],
    "310": ["1982", "1981"],
    "510": ["1981", "1979"],
    "620": ["1979", "1978", "1977", "1975"],
    "720": ["1982", "1981", "1980"],
    "810": ["1981", "1980", "1979"],
    "Pickup": ["1983", "1982", "1981", "1980"]
  },
  "Dodge": {
    "600": ["1988", "1987", "1986", "1985", "1984"],
    "Aries": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "Atos": ["2012", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Attitude": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Avenger": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2000", "1999", "1998", "1997", "1996", "1995"],
    "B150": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "B1500": ["1998", "1997", "1996", "1995"],
    "B250": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "B2500": ["1998", "1997", "1996", "1995"],
    "B350": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "B3500": ["1998", "1997", "1996", "1995"],
    "Caliber": ["2012", "2011", "2010", "2009", "2008", "2007"],
    "Caravan": ["2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Challenger": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Charger": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "1987", "1986", "1985", "1984", "1969", "1968"],
    "Colt": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1979", "1978", "1977"],
    "Conquest": ["1986", "1985", "1984"],
    "Coronet": ["1970"],
    "D100": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "D100 Pickup": ["1973", "1972"],
    "D150": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "D200 Pickup": ["1972"],
    "D250": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "D300 Pickup": ["1974", "1970"],
    "D350": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "D50": ["1982", "1981", "1980", "1979"],
    "Dakota": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Dart": ["2016", "2015", "2014", "2013", "1972", "1969"],
    "Daytona": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Diplomat": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "Durango": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "Dynasty": ["1993", "1992", "1991", "1990", "1989", "1988"],
    "Grand Caravan": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "H100": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "H100 Van": ["2013", "2012", "2011", "2010"],
    "Hornet": ["2024", "2023"],
    "Intrepid": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Journey": ["2023", "2022", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Lancer": ["1989", "1988", "1987", "1986", "1985"],
    "Magnum": ["2008", "2007", "2006", "2005"],
    "Mini Ram": ["1988", "1987", "1986", "1985", "1984"],
    "Monaco": ["1992", "1991", "1990", "1969"],
    "Neon": ["2020", "2018", "2017", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Nitro": ["2012", "2011", "2010", "2009", "2008", "2007"],
    "Omni": ["1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "P200": ["1972"],
    "Raider": ["1989", "1988", "1987"],
    "Ram 1500": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "Ram 1500 Van": ["2003", "2002", "2001", "2000", "1999", "1998"],
    "Ram 2500": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "Ram 2500 Van": ["2003", "2002", "2001", "2000", "1999"],
    "Ram 3500": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "Ram 3500 Van": ["2003", "2002", "2001", "2000", "1999"],
    "Ram 4000": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Ram 4500": ["2010", "2009", "2008"],
    "Ram 50": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "Ram 5500": ["2010", "2009", "2008"],
    "Ramcharger": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Rampage": ["1984"],
    "SX 2.0": ["2005", "2004", "2003"],
    "Shadow": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Spirit": ["1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Sprinter 2500": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Sprinter 3500": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Stealth": ["1996", "1995", "1994", "1993", "1992", "1991"],
    "Stratus": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Van 1000": ["2009", "2008"],
    "Verna": ["2006", "2005"],
    "Viper": ["2017", "2016", "2015", "2010", "2009", "2008", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Vision": ["2018", "2017", "2016", "2015"],
    "W100": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "W100 Pickup": ["1972"],
    "W150": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "W200 Pickup": ["1974", "1971", "1970"],
    "W250": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "W350": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "i10": ["2014", "2013", "2012"]
  },
  "Eagle": {
    "Premier": ["1992", "1991", "1990", "1989", "1988"],
    "Summit": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Talon": ["1998", "1997", "1996", "1995", "1994", "1993"],
    "Vision": ["1997", "1996", "1995", "1994", "1993"]
  },
  "Fiat": {
    "124 Spider": ["2020", "2019", "2018", "2017"],
    "500": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "500L": ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "500X": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"]
  },
  "Ford": {
    "Aerostar": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Aspire": ["1997", "1996", "1995", "1994"],
    "Bronco": ["2025", "2024", "2023", "2022", "2021", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1968"],
    "Bronco II": ["1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Bronco Sport": ["2026", "2025", "2024", "2023", "2022", "2021"],
    "C-Max": ["2018", "2017", "2016", "2015", "2014", "2013"],
    "Contour": ["2000", "1999", "1998", "1997", "1996", "1995"],
    "Country Squire": ["1991", "1990", "1989", "1988", "1987", "1974", "1970", "1966", "1962", "1958", "1957"],
    "Courier": ["2011", "2010", "2008"],
    "Crown Victoria": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Custom 500": ["1977", "1976", "1975", "1973", "1970", "1966", "1965"],
    "E-100 Econoline": ["1983", "1982", "1981", "1980", "1979", "1976"],
    "E-100 Econoline Club Wagon": ["1983", "1982", "1981", "1979", "1976", "1975"],
    "E-150": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "E-150 Club Wagon": ["2005", "2004", "2003"],
    "E-150 Econoline": ["2008", "2007", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1979", "1978", "1975"],
    "E-150 Econoline Club Wagon": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1979", "1978", "1977"],
    "E-250": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "E-250 Econoline": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1976"],
    "E-250 Econoline Club Wagon": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1980", "1979", "1978", "1975"],
    "E-350 Club Wagon": ["2005", "2004", "2003", "2002"],
    "E-350 Econoline": ["2008", "2007", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1978", "1977"],
    "E-350 Econoline Club Wagon": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "E-350 Super Duty": ["2026", "2025", "2024", "2023", "2022", "2021", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "E-450 Econoline Super Duty": ["2002", "2001", "2000", "1999"],
    "E-450 Super Duty": ["2026", "2025", "2024", "2022", "2021", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "E-550 Econoline Super Duty": ["2002"],
    "E-550 Super Duty": ["2003"],
    "E-Transit": ["2025", "2024", "2023", "2022"],
    "EXP": ["1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "EcoSport": ["2022", "2021", "2020", "2019", "2018", "2017", "2014", "2013", "2010"],
    "Econoline": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "Econoline Super Duty": ["1999", "1998", "1997", "1996"],
    "Econoline Van": ["2010"],
    "Econoline Wagon": ["2014", "2013", "2012", "2011", "2010"],
    "Edge": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Elite": ["1976", "1975"],
    "Escape": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Escort": ["2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "Excursion": ["2005", "2004", "2003", "2002", "2001", "2000"],
    "Expedition": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Explorer": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "Explorer Sport": ["2003", "2002", "2001"],
    "Explorer Sport Trac": ["2010", "2009", "2008", "2007", "2005", "2004", "2003", "2002", "2001"],
    "F-100": ["1983", "1982", "1981", "1979", "1978", "1977", "1976"],
    "F-150": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "F-150 Heritage": ["2004"],
    "F-150 Lightning": ["2025", "2024", "2023", "2022"],
    "F-250": ["2009", "2008", "2007", "2006", "2005", "2004", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "F-250 HD": ["1997"],
    "F-250 Super Duty": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "F-350": ["2016", "2009", "2007", "2006", "2005", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "F-350 Super Duty": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "F-450 Super Duty": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "F-53 Motorhome Chassis": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2009", "2008", "2007", "2006", "2004", "1997", "1996", "1995", "1989", "1988"],
    "F-550 Super Duty": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "F-59 Commercial Stripped Chassis": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "F-600 Super Duty": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "F-650": ["2026", "2025", "2024", "2023", "2022", "2021", "2019", "2018", "2017", "2016", "2015", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "F-750": ["2026", "2025", "2024", "2023", "2022", "2021", "2019", "2018", "2017", "2016", "2015", "2013"],
    "F-Super Duty": ["1997", "1996", "1995", "1994", "1993"],
    "Fairmont": ["1983", "1982", "1981", "1980", "1979", "1978"],
    "Festiva": ["1993", "1992", "1991", "1990", "1989", "1988"],
    "Fiesta": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2005", "1980", "1979", "1978"],
    "Fiesta Ikon": ["2011"],
    "Figo": ["2021", "2020", "2019"],
    "Five Hundred": ["2007", "2006", "2005"],
    "Flex": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Focus": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Freestar": ["2007", "2006", "2005", "2004"],
    "Freestyle": ["2007", "2006", "2005"],
    "Fusion": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "GT": ["2022", "2021", "2020", "2019", "2018", "2017", "2006", "2005"],
    "Gran Torino": ["1976", "1975"],
    "Granada": ["1982", "1981", "1980", "1978", "1977", "1976", "1975"],
    "Grand Marquis": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Ka": ["2005", "2004", "2003", "2002"],
    "LTD": ["1986", "1985", "1983", "1982", "1981", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968"],
    "LTD Crown Victoria": ["1991", "1990", "1989", "1988", "1987"],
    "LTD II": ["1978", "1977"],
    "Lobo": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2005", "2001", "2000", "1999", "1998", "1997"],
    "Maverick": ["2026", "2025", "2024", "2023", "2022", "1977", "1976", "1975", "1974"],
    "Mustang": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1973", "1970", "1969", "1968", "1967", "1966", "1965"],
    "Mustang II": ["1978", "1977", "1976", "1975", "1974"],
    "Mustang Mach-E": ["2025", "2024", "2023", "2022", "2021"],
    "Pinto": ["1980", "1978", "1977", "1976", "1975"],
    "Police Interceptor Sedan": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Police Interceptor Utility": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Police Responder Hybrid": ["2020", "2019"],
    "Probe": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Ranchero": ["1976"],
    "Ranger": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "SSV Plug-In Hybrid": ["2020", "2019"],
    "Special Service Police Sedan": ["2018", "2017", "2016", "2015", "2014"],
    "Taurus": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Taurus X": ["2009", "2008"],
    "Tempo": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Thunderbird": ["2005", "2004", "2003", "2002", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1978", "1977", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1965"],
    "Torino": ["1976", "1975"],
    "Transit": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Transit Connect": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Transit Custom": ["2021", "2020", "2019"],
    "Transit-150": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Transit-250": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Transit-350": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Transit-350 HD": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Windstar": ["2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"]
  },
  "Freightliner": {
    "Sprinter 1500": ["2020", "2019"],
    "Sprinter 2500": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Sprinter 3500": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Sprinter 3500XD": ["2021", "2020", "2019", "2018"]
  },
  "GMC": {
    "Acadia": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Acadia Limited": ["2017"],
    "B6000": ["1990", "1989", "1988", "1985", "1982", "1981"],
    "B7": ["2000", "1999"],
    "C1500": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1986", "1985", "1984", "1983", "1982", "1981"],
    "C1500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1986", "1985", "1984"],
    "C2500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1986", "1985", "1984", "1983", "1982", "1981"],
    "C2500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1986", "1985", "1984", "1983", "1982", "1981"],
    "C3500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1986", "1985", "1984", "1983", "1982", "1981"],
    "C3500HD": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "C4500 Topkick": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "C5500 Topkick": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "C6000 Topkick": ["1993", "1992", "1990"],
    "C6500 Topkick": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "C7000": ["1990", "1988", "1987", "1986", "1985", "1983"],
    "C7500 Topkick": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "C8500 Topkick": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Caballero": ["1987", "1986", "1985", "1984"],
    "Canyon": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Envoy": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Envoy XL": ["2006", "2005", "2004", "2003", "2002"],
    "Envoy XUV": ["2005", "2004"],
    "G1500": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "G2500": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "G3500": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "Hummer EV Pickup": ["2026", "2025", "2024", "2023", "2022"],
    "Hummer EV SUV": ["2026", "2025", "2024"],
    "Jimmy": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1973"],
    "K1500": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1986", "1985", "1984", "1983", "1982", "1981"],
    "K1500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1986", "1985", "1984"],
    "K2500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1986", "1985", "1984", "1983", "1982", "1981"],
    "K2500 Suburban": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1986", "1985", "1984", "1983", "1982", "1981"],
    "K3500": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1986", "1985", "1984", "1983", "1982", "1981"],
    "P2500": ["1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "P3500": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "R1500": ["1987"],
    "R1500 Suburban": ["1991", "1990", "1989", "1988", "1987"],
    "R2500": ["1989", "1988", "1987"],
    "R2500 Suburban": ["1991", "1990", "1989", "1988", "1987"],
    "R3500": ["1991", "1990", "1989", "1988", "1987"],
    "S15": ["1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "S15 Jimmy": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Safari": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Savana 1500": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Savana 2500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Savana 3500": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Savana 4500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Sierra": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Sierra 1500": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Sierra 1500 Classic": ["2007"],
    "Sierra 1500 HD": ["2006", "2005", "2003", "2002", "2001"],
    "Sierra 1500 HD Classic": ["2007"],
    "Sierra 1500 Limited": ["2022", "2019"],
    "Sierra 2500": ["2004", "2003", "2002", "2001", "2000", "1999"],
    "Sierra 2500 HD": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Sierra 2500 HD Classic": ["2007"],
    "Sierra 3500": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "Sierra 3500 Classic": ["2007"],
    "Sierra 3500 HD": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Sierra EV": ["2026", "2025", "2024"],
    "Sierra Nueva": ["2022"],
    "Sonoma": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "Syclone": ["1991"],
    "T6500": ["2009", "2008", "2007", "2006", "2005", "2004", "1998", "1997"],
    "T7500": ["2009", "2008", "2007", "2006", "2005", "2004", "1998", "1997"],
    "Terrain": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Tracker": ["1991", "1990", "1989"],
    "Typhoon": ["1993", "1992"],
    "V1500": ["1987"],
    "V1500 Suburban": ["1991", "1990", "1989", "1988", "1987"],
    "V2500": ["1987"],
    "V2500 Suburban": ["1991", "1990", "1989", "1988", "1987"],
    "V3500": ["1991", "1990", "1989", "1988", "1987"],
    "Yukon": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Yukon XL": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Yukon XL 1500": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Yukon XL 2500": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"]
  },
  "Genesis": {
    "Electrified G80": ["2025", "2024", "2023"],
    "Electrified GV70": ["2025", "2024", "2023"],
    "G70": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "G80": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "G90": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "GV60": ["2024", "2023"],
    "GV70": ["2025", "2024", "2023", "2022"],
    "GV80": ["2025", "2024", "2023", "2022", "2021"]
  },
  "Geo": {
    "Metro": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Prizm": ["1992", "1991", "1990", "1989"],
    "Storm": ["1993", "1992", "1991", "1990"],
    "Tracker": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"]
  },
  "Honda": {
    "600": ["1972", "1971", "1970", "1969"],
    "Accord": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "Accord Crosstour": ["2011", "2010"],
    "BR-V": ["2024", "2022", "2021", "2020", "2019", "2018"],
    "CR-V": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "CR-Z": ["2016", "2015", "2014", "2013", "2012", "2011"],
    "CRX": ["1991", "1990", "1989", "1988"],
    "City": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Civic": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973"],
    "Civic del Sol": ["1997", "1996", "1995", "1994", "1993"],
    "Clarity": ["2021", "2020", "2019", "2018", "2017"],
    "Clarity Plug-In Hybrid": ["2018"],
    "Crosstour": ["2015", "2014", "2013", "2012"],
    "EV Plus": ["1999", "1998"],
    "Element": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Fit": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "HR-V": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Insight": ["2022", "2021", "2020", "2019", "2014", "2013", "2012", "2011", "2010", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Odyssey": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Passport": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "Pilot": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Prelude": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979"],
    "Prologue": ["2024"],
    "Ridgeline": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "S2000": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Wagovan": ["1987", "1986", "1984"]
  },
  "Hummer": {
    "H1": ["2006"],
    "H2": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "H3": ["2010", "2009", "2008", "2007", "2006"],
    "H3T": ["2010", "2009"]
  },
  "Hyundai": {
    "Accent": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Azera": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Creta": ["2019", "2018", "2017"],
    "Elantra": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Elantra Coupe": ["2014", "2013"],
    "Elantra GT": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Elantra N": ["2024", "2023", "2022"],
    "Entourage": ["2010", "2009", "2008", "2007"],
    "Equus": ["2016", "2015", "2014", "2013", "2012", "2011"],
    "Excel": ["1994"],
    "Genesis": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Genesis Coupe": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Grand i10": ["2019", "2018", "2017", "2016", "2015"],
    "Ioniq": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "Ioniq 5": ["2024", "2023", "2022"],
    "Ioniq 6": ["2024", "2023"],
    "Kona": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Kona Electric": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "Kona N": ["2023", "2022"],
    "Nexo": ["2021", "2020", "2019"],
    "Palisade": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "Santa Cruz": ["2025", "2024", "2023", "2022"],
    "Santa Fe": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Santa Fe Sport": ["2018", "2017", "2016", "2015", "2014", "2013"],
    "Santa Fe XL": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Scoupe": ["1995", "1994", "1993"],
    "Sonata": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Starex": ["2019"],
    "Tiburon": ["2008", "2007", "2006", "2005", "2004", "2003", "2001", "2000", "1999", "1998", "1997"],
    "Tucson": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Veloster": ["2021", "2020", "2019", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Veloster N": ["2022", "2021", "2020", "2019"],
    "Venue": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "Veracruz": ["2012", "2011", "2010", "2009", "2008", "2007"],
    "XG300": ["2001"],
    "XG350": ["2005", "2004", "2003", "2002"],
    "ix35": ["2015"]
  },
  "INFINITI": {
    "EX35": ["2012", "2011", "2010", "2009", "2008"],
    "EX37": ["2013"],
    "FX35": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "FX37": ["2013"],
    "FX45": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "FX50": ["2013", "2012", "2011", "2010", "2009"],
    "G20": ["2002", "2001", "2000", "1999", "1996", "1995", "1994", "1993", "1992", "1991"],
    "G25": ["2012", "2011"],
    "G35": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "G37": ["2013", "2012", "2011", "2010", "2009", "2008"],
    "I30": ["2001", "2000", "1999", "1998", "1997", "1996"],
    "I35": ["2004", "2003", "2002"],
    "J30": ["1997", "1996", "1995", "1994", "1993"],
    "JX35": ["2013"],
    "M30": ["1992", "1991", "1990"],
    "M35": ["2010", "2009", "2008", "2007", "2006"],
    "M35h": ["2013", "2012"],
    "M37": ["2013", "2012", "2011"],
    "M45": ["2010", "2009", "2008", "2007", "2006", "2004", "2003"],
    "M56": ["2013", "2012", "2011"],
    "Q40": ["2015"],
    "Q45": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Q50": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Q60": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Q70": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "Q70L": ["2019", "2018", "2017", "2016", "2015"],
    "QX30": ["2019", "2018", "2017"],
    "QX4": ["2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "QX50": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2017", "2016", "2015", "2014"],
    "QX55": ["2025", "2024", "2023", "2022"],
    "QX56": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "QX60": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "QX70": ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "QX80": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"]
  },
  "Isuzu": {
    "Amigo": ["2000", "1999"],
    "Ascender": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "Hombre": ["2000", "1999", "1998", "1997", "1996"],
    "Impulse": ["1992", "1991", "1990", "1989"],
    "Oasis": ["1999", "1998", "1997", "1996"],
    "Rodeo": ["2003", "2002", "2001", "2000", "1999", "1998"],
    "Rodeo Sport": ["2003", "2002", "2001"],
    "Stylus": ["1993", "1992", "1991"],
    "Trooper": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "i-280": ["2006"],
    "i-290": ["2008", "2007"],
    "i-350": ["2006"],
    "i-370": ["2008", "2007"]
  },
  "Jaguar": {
    "E-Pace": ["2019", "2018"],
    "F-Pace": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "F-Type": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "I-Pace": ["2023", "2022", "2020", "2019"],
    "S-Type": ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Super V8": ["2009", "2008", "2007", "2006", "2005"],
    "Vanden Plas": ["2009", "2008", "2007", "2006", "2005", "2004", "1997", "1996", "1995"],
    "X-Type": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "XE": ["2020", "2019", "2018", "2017", "2016"],
    "XF": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "XFR": ["2015", "2014", "2013", "2012", "2011", "2010"],
    "XFR-S": ["2015", "2014", "2013"],
    "XJ": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "XJ12": ["1996", "1995"],
    "XJ6": ["1997", "1996", "1995", "1987", "1986", "1985"],
    "XJ8": ["2009", "2008", "2007", "2006", "2005", "2004"],
    "XJR": ["2017", "2016", "2015", "2014", "2009", "2008", "2007", "2006", "2005", "2004", "1997", "1996", "1995"],
    "XJR575": ["2019", "2018"],
    "XJS": ["1995", "1994", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "XK": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "XK8": ["2006", "2005", "2004", "2003"],
    "XKR": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "XKR-S": ["2015", "2014", "2013", "2012"]
  },
  "Jeep": {
    "CJ5": ["1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972"],
    "CJ6": ["1975", "1974", "1973", "1972"],
    "CJ7": ["1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "Cherokee": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Comanche": ["1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Commander": ["2010", "2009", "2008", "2007", "2006"],
    "Compass": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "DJ5": ["1983", "1982", "1981", "1980", "1979"],
    "Gladiator": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "Grand Cherokee": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Grand Cherokee L": ["2024", "2023", "2022", "2021"],
    "Grand Cherokee WK": ["2022"],
    "Grand Wagoneer": ["2024", "2023", "2022", "1993", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Grand Wagoneer L": ["2024", "2023"],
    "J10": ["1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "J20": ["1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Liberty": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Patriot": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Renegade": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "TJ": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Wagoneer": ["2025", "2024", "2023", "2022", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Wagoneer L": ["2024", "2023"],
    "Wrangler": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Wrangler JK": ["2018"]
  },
  "Kia": {
    "Amanti": ["2009", "2008", "2007", "2006", "2005", "2004"],
    "Borrego": ["2011", "2010", "2009"],
    "Cadenza": ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Carnival": ["2025", "2024", "2023", "2022"],
    "EV6": ["2024", "2023", "2022"],
    "Forte": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Forte Koup": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Forte5": ["2021", "2020", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "K4": ["2025"],
    "K5": ["2025", "2024", "2023", "2022", "2021"],
    "K900": ["2020", "2019", "2017", "2016", "2015"],
    "Magentis": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Niro": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Niro EV": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "Optima": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Rio": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Rio5": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "Rondo": ["2017", "2016", "2015", "2014", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Sedona": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Seltos": ["2025", "2024", "2023", "2022", "2021"],
    "Sephia": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "Sorento": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Soul": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Soul EV": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Spectra": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Spectra5": ["2009", "2008", "2007", "2006", "2005"],
    "Sportage": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Stinger": ["2023", "2022", "2021", "2020", "2019", "2018"],
    "Telluride": ["2025", "2024", "2023", "2022", "2021", "2020"]
  },
  "Laforza": {
    "Laforza": ["1990", "1989"]
  },
  "Land Rover": {
    "Defender": ["2016", "2015", "2014", "2013", "2012", "2011"],
    "Defender 110": ["2025", "2024", "2023", "2022", "2021", "2020", "1993"],
    "Defender 130": ["2025", "2024", "2023"],
    "Defender 90": ["2025", "2024", "2023", "2022", "2021", "1997", "1995", "1994"],
    "Discovery": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "Discovery Sport": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Freelander": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "LR2": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "LR3": ["2009", "2008", "2007", "2006", "2005"],
    "LR4": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Land Rover": ["1974", "1973", "1972", "1971", "1970", "1959", "1958", "1957", "1956", "1955", "1954", "1953", "1952", "1951", "1950", "1949", "1948"],
    "Range Rover": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Range Rover Evoque": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Range Rover Sport": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Range Rover Velar": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"]
  },
  "Lexus": {
    "CT200h": ["2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "ES250": ["2024", "2023", "2022", "2021", "1991", "1990"],
    "ES300": ["2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "ES300h": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "ES330": ["2006", "2005", "2004"],
    "ES350": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "GS F": ["2020", "2019", "2018", "2017", "2016"],
    "GS200t": ["2017", "2016"],
    "GS300": ["2019", "2018", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "GS350": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2011", "2010", "2009", "2008", "2007"],
    "GS400": ["2000", "1999", "1998"],
    "GS430": ["2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "GS450h": ["2018", "2017", "2016", "2015", "2014", "2013", "2011", "2010", "2009", "2008", "2007"],
    "GS460": ["2011", "2010", "2009", "2008"],
    "GX460": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "GX470": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "HS250h": ["2012", "2011", "2010"],
    "IS F": ["2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "IS200t": ["2017", "2016"],
    "IS250": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "IS300": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2005", "2004", "2003", "2002", "2001"],
    "IS350": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "IS500": ["2024", "2023", "2022"],
    "LC500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "LC500h": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "LFA": ["2012"],
    "LS400": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "LS430": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "LS460": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "LS500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "LS500h": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "LS600h": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "LX450": ["1997", "1996"],
    "LX470": ["2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "LX570": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2011", "2010", "2009", "2008"],
    "LX600": ["2024", "2023", "2022"],
    "NX200t": ["2017", "2016", "2015"],
    "NX250": ["2024", "2023", "2022"],
    "NX300": ["2021", "2020", "2019", "2018"],
    "NX300h": ["2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "NX350": ["2024", "2023", "2022"],
    "NX350h": ["2024", "2023", "2022"],
    "NX450h+": ["2024", "2023", "2022"],
    "RC F": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "RC200t": ["2017", "2016"],
    "RC300": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "RC350": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "RX300": ["2003", "2002", "2001", "2000", "1999"],
    "RX330": ["2006", "2005", "2004"],
    "RX350": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "RX350L": ["2022", "2021", "2020", "2019", "2018"],
    "RX350h": ["2023"],
    "RX400h": ["2008", "2007", "2006"],
    "RX450h": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "RX450hL": ["2022", "2021", "2020", "2019", "2018"],
    "RX500h": ["2023"],
    "RZ450e": ["2023"],
    "SC300": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "SC400": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "SC430": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "TX550h+": ["2025", "2024"],
    "UX200": ["2022", "2021", "2020", "2019"],
    "UX250h": ["2023", "2022", "2021", "2020", "2019"]
  },
  "Lincoln": {
    "Aviator": ["2025", "2024", "2023", "2022", "2021", "2020", "2005", "2004", "2003"],
    "Blackwood": ["2003", "2002"],
    "Continental": ["2020", "2019", "2018", "2017", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1979", "1977"],
    "Corsair": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "LS": ["2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "MKC": ["2019", "2018", "2017", "2016", "2015"],
    "MKS": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "MKT": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "MKX": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "MKZ": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Mark LT": ["2014", "2013", "2012", "2011", "2010", "2008", "2007", "2006"],
    "Mark V": ["1979", "1978"],
    "Mark VI": ["1983", "1982", "1981", "1980"],
    "Mark VII": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Mark VIII": ["1998", "1997", "1996", "1995", "1994", "1993"],
    "Nautilus": ["2023", "2022", "2021", "2020", "2019"],
    "Navigator": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "Town Car": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Versailles": ["1980"],
    "Zephyr": ["2006"]
  },
  "Maserati": {
    "Ghibli": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "GranCabrio": ["2019", "2017", "2016", "2015", "2014", "2013", "2011", "2010"],
    "GranSport": ["2007", "2006", "2005"],
    "GranTurismo": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Levante": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "Quattroporte": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"]
  },
  "Mazda": {
    "1200": ["1972"],
    "2": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "3": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "3 Sport": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2010", "2009"],
    "323": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "5": ["2017", "2016", "2015", "2014", "2013", "2012", "2010", "2009", "2008", "2007", "2006"],
    "6": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "626": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "929": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "B2000": ["1987", "1986"],
    "B2200": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1984"],
    "B2300": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "1997", "1996", "1995", "1994"],
    "B2500": ["2001", "2000", "1999", "1998"],
    "B2600": ["1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "B3000": ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1996", "1995", "1994"],
    "B4000": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "CX-3": ["2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "CX-30": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "CX-5": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "CX-50": ["2025", "2024", "2023"],
    "CX-7": ["2012", "2011", "2010", "2009", "2008", "2007"],
    "CX-70": ["2025"],
    "CX-9": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "CX-90": ["2025", "2024"],
    "GLC": ["1985", "1984"],
    "MPV": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "MX-3": ["1996", "1995", "1994", "1993", "1992"],
    "MX-30 EV": ["2023", "2022"],
    "MX-5": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "MX-5 Miata": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "MX-6": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "Miata": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Millenia": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Navajo": ["1994", "1993", "1992", "1991"],
    "Protege": ["2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Protege5": ["2003", "2002"],
    "RX-3": ["1978"],
    "RX-4": ["1978"],
    "RX-7": ["1995", "1994", "1993", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "RX-8": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Tribute": ["2011", "2010", "2009", "2008", "2006", "2005", "2004", "2003", "2002", "2001"]
  },
  "Mercedes-Benz": {
    "190D": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "190E": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "230": ["1978", "1977", "1976", "1975"],
    "240D": ["1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "250SE": ["1968", "1967", "1966"],
    "250SL": ["1968", "1967", "1966"],
    "260E": ["1989", "1988", "1987"],
    "280": ["1976", "1975"],
    "280C": ["1976", "1975"],
    "280CE": ["1981", "1980", "1979", "1978"],
    "280E": ["1981", "1980", "1979", "1978", "1977"],
    "280S": ["1976", "1975"],
    "280SE": ["1980", "1979", "1978", "1977", "1973", "1972", "1971", "1970", "1969", "1968"],
    "280SEL": ["1973", "1972", "1971", "1970", "1969", "1968"],
    "280SL": ["1971", "1970", "1969", "1968"],
    "300CD": ["1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "300CE": ["1993", "1992", "1991", "1990", "1989", "1988"],
    "300D": ["1993", "1992", "1991", "1990", "1987", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "300E": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "300SD": ["1993", "1992", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "300SDL": ["1987", "1986"],
    "300SE": ["1993", "1992", "1991", "1990", "1989", "1988"],
    "300SEL": ["1991", "1990", "1989", "1988"],
    "300SL": ["1993", "1992", "1991", "1990"],
    "300TD": ["1987", "1985", "1984", "1983", "1982", "1981", "1980", "1979"],
    "300TE": ["1993", "1992", "1991", "1990", "1989", "1988"],
    "350SD": ["1991"],
    "350SDL": ["1991", "1990"],
    "380SE": ["1985", "1984"],
    "380SEC": ["1983", "1982"],
    "380SEL": ["1983", "1982", "1981"],
    "380SL": ["1985", "1984", "1983", "1982", "1981"],
    "380SLC": ["1981"],
    "400E": ["1993", "1992"],
    "400SE": ["1992"],
    "400SEL": ["1993"],
    "420SEL": ["1991", "1990", "1989", "1988", "1987", "1986"],
    "450SE": ["1976", "1975"],
    "450SEL": ["1980", "1979", "1978", "1977", "1976", "1975"],
    "450SL": ["1980", "1979", "1978", "1977", "1976", "1975"],
    "450SLC": ["1980", "1979", "1978", "1977", "1976", "1975"],
    "500E": ["1993", "1992"],
    "500SEC": ["1993", "1985", "1984"],
    "500SEL": ["1993", "1992", "1985", "1984"],
    "500SL": ["1993", "1992", "1991", "1990"],
    "560SEC": ["1991", "1990", "1989", "1988", "1987", "1986"],
    "560SEL": ["1991", "1990", "1989", "1988", "1987", "1986"],
    "560SL": ["1989", "1988", "1987", "1986"],
    "600SEC": ["1993"],
    "600SEL": ["1993", "1992"],
    "600SL": ["1993"],
    "A160": ["2005", "2004", "2003", "2002"],
    "A180": ["2016", "2015", "2014", "2013"],
    "A190": ["2005", "2004", "2003", "2002", "2001"],
    "A200": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "A220": ["2022", "2021", "2020", "2019"],
    "A250": ["2022", "2021", "2020", "2019", "2017", "2014", "2013"],
    "A35 AMG": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "A45": ["2017"],
    "A45 AMG": ["2018", "2017", "2016", "2015", "2014"],
    "A45 AMG S": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "AMG GT": ["2021", "2020", "2019", "2018", "2017"],
    "AMG GT 43": ["2024", "2023", "2022", "2021"],
    "AMG GT 53": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "AMG GT 55": ["2025", "2024"],
    "AMG GT 63": ["2025", "2024", "2023", "2021", "2020", "2019"],
    "AMG GT 63 S": ["2023", "2021", "2020", "2019"],
    "AMG GT 63 S E Performance": ["2025", "2024"],
    "AMG GT Black Series": ["2021"],
    "AMG GT C": ["2021", "2020", "2019", "2018"],
    "AMG GT R": ["2021", "2020", "2019", "2018"],
    "AMG GT R Pro": ["2020"],
    "AMG GT S": ["2020", "2019", "2018", "2017", "2016"],
    "Allegro": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Alliado": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Andare": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "B Electric Drive": ["2015", "2014"],
    "B180": ["2015", "2014", "2013", "2012"],
    "B200": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "B250": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "B250e": ["2017", "2016"],
    "Boxer 40": ["2021", "2019", "2018", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Boxer 50": ["2021", "2019", "2018", "2017", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Boxer 60": ["2023", "2022", "2021", "2019", "2018", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Boxer OF": ["2021", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Busstar 380": ["2021"],
    "C180": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "C200": ["2024", "2023", "2022", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2004", "2003", "2002", "2001"],
    "C220": ["1997", "1996", "1995", "1994"],
    "C230": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2000", "1999", "1998", "1997", "1996"],
    "C240": ["2005", "2004", "2003", "2002", "2001"],
    "C250": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "C280": ["2009", "2008", "2007", "2006", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "C300": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "C32 AMG": ["2004", "2003", "2002"],
    "C320": ["2005", "2004", "2003", "2002", "2001"],
    "C350": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "C350e": ["2018", "2017", "2016"],
    "C36 AMG": ["1997", "1996", "1995"],
    "C400": ["2015"],
    "C43 AMG": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2000", "1999", "1998"],
    "C450 AMG": ["2016"],
    "C55 AMG": ["2007", "2006", "2005"],
    "C63 AMG": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "C63 AMG S": ["2023", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "C63 AMG S E Performance": ["2025", "2024"],
    "CL200": ["2003", "2002"],
    "CL230": ["2005", "2004", "2003", "2002"],
    "CL500": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "CL55 AMG": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "CL550": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "CL600": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "1999", "1998", "1997", "1996"],
    "CL63 AMG": ["2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "CL65 AMG": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005"],
    "CLA180": ["2017", "2016", "2015"],
    "CLA200": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "CLA250": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "CLA35 AMG": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "CLA45 AMG": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "CLA45 AMG S": ["2025", "2024"],
    "CLE300": ["2025", "2024"],
    "CLE450": ["2025", "2024"],
    "CLE53 AMG": ["2025", "2024"],
    "CLK280": ["2009", "2008", "2007"],
    "CLK320": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "CLK350": ["2009", "2008", "2007", "2006"],
    "CLK430": ["2003", "2002", "2001", "2000", "1999"],
    "CLK500": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "CLK55 AMG": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "CLK550": ["2009", "2008", "2007"],
    "CLK63 AMG": ["2009", "2008", "2007"],
    "CLS350": ["2023", "2022", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "CLS400": ["2018", "2017", "2016", "2015"],
    "CLS450": ["2023", "2022", "2021", "2020", "2019"],
    "CLS500": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "CLS53 AMG": ["2023", "2022", "2021", "2020", "2019"],
    "CLS53 AMG S": ["2019"],
    "CLS55 AMG": ["2006"],
    "CLS550": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "CLS63 AMG": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "CLS63 AMG S": ["2018", "2017", "2016", "2015", "2014"],
    "Citaro": ["2006"],
    "Coraza S2": ["2019", "2018", "2017", "2016", "2014", "2013", "2012"],
    "E200": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "E250": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "E280": ["2009", "2008", "2007", "1999"],
    "E300": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "1999", "1998", "1997", "1996", "1995"],
    "E320": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "E350": ["2025", "2024", "2023", "2022", "2021", "2020", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "E350e": ["2023", "2022", "2021"],
    "E400": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "E420": ["1999", "1998", "1997", "1995", "1994"],
    "E43 AMG": ["2020", "2019", "2018", "2017"],
    "E430": ["2002", "2001", "2000", "1999", "1998"],
    "E450": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "E500": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "1997", "1994"],
    "E53 AMG": ["2025", "2023", "2022", "2021", "2020", "2019"],
    "E55 AMG": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "E550": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "E63 AMG": ["2021", "2020", "2018", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "E63 AMG S": ["2023", "2022", "2021", "2020", "2019", "2018", "2016", "2015", "2014"],
    "EQA300": ["2024", "2023", "2022"],
    "EQB 250+": ["2024", "2023"],
    "EQB 300": ["2025", "2024", "2023", "2022"],
    "EQB 350": ["2025", "2024", "2023", "2022"],
    "EQC400": ["2023", "2022", "2021"],
    "EQE 350": ["2025", "2024", "2023"],
    "EQE 350 SUV": ["2025", "2024", "2023"],
    "EQE 350+": ["2025", "2024", "2023"],
    "EQE 350+ SUV": ["2025", "2024", "2023"],
    "EQE 500": ["2025", "2024", "2023"],
    "EQE 500 SUV": ["2025", "2024", "2023"],
    "EQE 53 AMG": ["2024"],
    "EQE AMG": ["2025", "2024", "2023"],
    "EQE AMG SUV": ["2025", "2024"],
    "EQS 450": ["2025", "2024", "2023"],
    "EQS 450 SUV": ["2025", "2024", "2023"],
    "EQS 450+": ["2025", "2024", "2023", "2022"],
    "EQS 450+ SUV": ["2025", "2024", "2023"],
    "EQS 53 AMG": ["2024", "2023"],
    "EQS 580": ["2025", "2024", "2023", "2022"],
    "EQS 580 SUV": ["2025", "2024", "2023"],
    "EQS AMG": ["2025", "2024", "2023", "2022"],
    "FS65": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "G500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "G55 AMG": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "G550": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "G550 4x4": ["2018", "2017"],
    "G580": ["2025"],
    "G63 4x4 Squared AMG": ["2024", "2023", "2022"],
    "G63 AMG": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "G65 AMG": ["2018", "2017", "2016", "2015", "2014"],
    "GL320": ["2009", "2008", "2007"],
    "GL350": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "GL450": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "GL500": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "GL550": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "GL63 AMG": ["2016", "2015", "2014", "2013"],
    "GLA180": ["2018", "2017", "2016"],
    "GLA200": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "GLA250": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "GLA35 AMG": ["2025", "2024", "2023", "2022", "2021"],
    "GLA45 AMG": ["2023", "2022", "2021", "2019", "2018", "2017", "2016", "2015", "2014"],
    "GLB200": ["2024", "2023", "2022", "2021"],
    "GLB250": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "GLB35 AMG": ["2025", "2024", "2023", "2022", "2021"],
    "GLC250": ["2018", "2017"],
    "GLC300": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "GLC300e": ["2023", "2022", "2021"],
    "GLC350e": ["2025", "2020", "2019", "2018"],
    "GLC43 AMG": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "GLC63 AMG": ["2021", "2020", "2019", "2018"],
    "GLC63 AMG S": ["2021", "2020", "2019", "2018"],
    "GLC63 AMG S E Performance": ["2025"],
    "GLE300d": ["2017", "2016"],
    "GLE350": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "GLE350d": ["2016"],
    "GLE400": ["2019", "2018", "2017", "2016"],
    "GLE43 AMG": ["2020", "2019", "2018", "2017"],
    "GLE450": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "GLE450 AMG": ["2017", "2016"],
    "GLE450 SUV": ["2025", "2024", "2023", "2022"],
    "GLE450e": ["2025", "2024"],
    "GLE500": ["2019", "2018", "2017", "2016"],
    "GLE500e": ["2019", "2018"],
    "GLE53 AMG": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "GLE53 AMG SUV": ["2023", "2022", "2021"],
    "GLE550": ["2018", "2017", "2016"],
    "GLE550e": ["2018", "2017", "2016"],
    "GLE580": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "GLE63 AMG": ["2022", "2020", "2019", "2018", "2017", "2016"],
    "GLE63 AMG S": ["2025", "2024", "2023", "2022", "2021", "2019", "2018", "2017", "2016"],
    "GLE63 AMG S SUV": ["2025", "2024", "2023", "2022", "2021"],
    "GLK250": ["2015", "2014", "2013"],
    "GLK280": ["2009"],
    "GLK300": ["2015", "2014", "2013", "2012", "2011", "2010"],
    "GLK350": ["2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "GLS350d": ["2017"],
    "GLS450": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "GLS500": ["2019", "2017"],
    "GLS550": ["2019", "2018", "2017"],
    "GLS580": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "GLS63 AMG": ["2025", "2024", "2023", "2022", "2021", "2019", "2018", "2017"],
    "Gran Viale": ["2014", "2013", "2012"],
    "Gran Viale Articulado": ["2020", "2019", "2018", "2017", "2016", "2015", "2011", "2010", "2009", "2008", "2007"],
    "Gran Viale LE": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Gran Viale RF": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "HDX": ["2014"],
    "L1013": ["1983", "1982", "1981"],
    "L1113": ["1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "L1116": ["1984", "1983", "1982", "1981"],
    "L1117": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "L1316": ["1984", "1983", "1982", "1981"],
    "L1317": ["1986", "1985", "1984"],
    "L1319": ["1991", "1990", "1989", "1988", "1987"],
    "L1413": ["1969", "1968", "1967", "1966", "1965", "1964", "1963"],
    "L1418": ["1969", "1968", "1967", "1966", "1965", "1964", "1963"],
    "LO 915": ["2009", "2008", "2007", "2006", "2005"],
    "LO 916": ["2024", "2023", "2022", "2021", "2020"],
    "LP1219": ["1991", "1990", "1989", "1988", "1987"],
    "LP1419": ["1991", "1990", "1989", "1988", "1987", "1986"],
    "LPS1525": ["1990", "1989", "1988", "1987", "1986"],
    "MBO 1018": ["2023", "2022", "2021", "2020"],
    "MBO 12000": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "MBO 1218": ["2022", "2021", "2020"],
    "MBO 1221": ["2024", "2023", "2022", "2021", "2020"],
    "MBO 14000": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "MBO 1421": ["2024", "2023", "2022", "2021", "2020"],
    "ML250": ["2015"],
    "ML320": ["2009", "2008", "2007", "2003", "2002", "2001", "2000", "1999", "1998"],
    "ML350": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "ML400": ["2015"],
    "ML430": ["2001", "2000", "1999", "1998"],
    "ML450": ["2011", "2010"],
    "ML500": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "ML55 AMG": ["2003", "2002", "2001", "2000"],
    "ML550": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "ML63 AMG": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "MP60 Express": ["2021"],
    "Marco Polo": ["2023", "2022", "2021"],
    "Maybach EQS 680 SUV": ["2025", "2024"],
    "Maybach GLS600": ["2025", "2024", "2023", "2022", "2021"],
    "Maybach S550": ["2017"],
    "Maybach S560": ["2020", "2019", "2018"],
    "Maybach S580": ["2025", "2024", "2023", "2022", "2021"],
    "Maybach S600": ["2017", "2016"],
    "Maybach S650": ["2022", "2020", "2019", "2018"],
    "Maybach S680": ["2024", "2023", "2022"],
    "Maybach SL680": ["2026"],
    "Metris": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Multego": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "O400": ["2006", "2005"],
    "O500": ["2024", "2023", "2022", "2021", "2020", "2009", "2008", "2007", "2006", "2005"],
    "OC 500": ["2023", "2022", "2021", "2020", "2012", "2011"],
    "OF 1118": ["2022", "2021", "2020"],
    "OF 1318": ["2022", "2021", "2020"],
    "OF 1321": ["2024", "2023", "2022", "2021", "2020"],
    "OF 1421": ["2024"],
    "OH 1500": ["2010", "2009"],
    "OH 1518": ["2022", "2021", "2020"],
    "OH 1524": ["2022", "2021", "2020"],
    "OH 1600": ["2010"],
    "OH 1621": ["2024", "2023", "2022", "2021", "2020"],
    "OH 1624": ["2024", "2023", "2022", "2021", "2020"],
    "OH 1625": ["2023", "2022", "2021", "2020"],
    "OMC 1400": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "OMC 1600": ["2006", "2005"],
    "Paradiso 1200": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Paradiso 1350": ["2021", "2020", "2019", "2018", "2017", "2016", "2014", "2013"],
    "Paradiso 1800": ["2018", "2017", "2014", "2013"],
    "R320": ["2009", "2008", "2007"],
    "R350": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "R500": ["2008", "2007", "2006"],
    "R550": ["2008"],
    "R63 AMG": ["2007"],
    "S 417": ["2006", "2005"],
    "S320": ["1999", "1998", "1997", "1996", "1995", "1994"],
    "S350": ["2013", "2012", "2011", "2006", "1995", "1994"],
    "S400": ["2015", "2014", "2013", "2012", "2011", "2010"],
    "S400L": ["2018", "2017", "2016"],
    "S420": ["1999", "1998", "1997", "1996", "1995", "1994"],
    "S430": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "S450": ["2020", "2019", "2018", "2011", "2010", "2009", "2008"],
    "S450L": ["2023", "2022", "2021", "2020", "2019"],
    "S500": ["2025", "2024", "2023", "2022", "2021", "2018", "2017", "2016", "2015", "2014", "2013", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "S500L": ["2018", "2017", "2015"],
    "S55 AMG": ["2006", "2005", "2004", "2003", "2002", "2001"],
    "S550": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "S550e": ["2017", "2016", "2015"],
    "S560": ["2021", "2020", "2019", "2018"],
    "S560L": ["2020", "2019"],
    "S560e": ["2020", "2019"],
    "S580": ["2025", "2024", "2023", "2022", "2021"],
    "S580e": ["2025", "2024", "2023"],
    "S600": ["2017", "2016", "2015", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "S600L": ["2020", "2019", "2018", "2017", "2016"],
    "S63 AMG": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "S63L AMG": ["2017", "2016"],
    "S65 AMG": ["2020", "2019", "2018", "2017", "2016", "2015", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "S65L AMG": ["2017", "2016"],
    "SL320": ["1997", "1996", "1995", "1994"],
    "SL400": ["2016", "2015"],
    "SL43 AMG": ["2024", "2023"],
    "SL450": ["2020", "2019", "2018", "2017"],
    "SL500": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "SL55 AMG": ["2025", "2024", "2023", "2022", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "SL550": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "SL60 AMG": ["1999", "1998", "1997"],
    "SL600": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    "SL63 AMG": ["2025", "2024", "2023", "2022", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "SL63 AMG S E Performance": ["2025", "2024"],
    "SL65 AMG": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "SLC180": ["2020", "2019", "2018", "2017"],
    "SLC200": ["2017"],
    "SLC300": ["2020", "2019", "2018", "2017"],
    "SLC43 AMG": ["2020", "2019", "2018", "2017"],
    "SLK200": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "SLK230": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "SLK250": ["2015", "2014", "2013", "2012"],
    "SLK280": ["2008", "2007", "2006"],
    "SLK300": ["2016", "2011", "2010", "2009"],
    "SLK32 AMG": ["2004", "2003", "2002"],
    "SLK320": ["2004", "2003", "2002", "2001"],
    "SLK350": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "SLK55 AMG": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "SLR McLaren": ["2009", "2008", "2007", "2006", "2005"],
    "SLS AMG": ["2015", "2014", "2013", "2012", "2011"],
    "Safety Bus": ["2020", "2019", "2018"],
    "Sprinter": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Sprinter 1500": ["2023", "2022", "2021", "2020", "2019"],
    "Sprinter 2500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Sprinter 3500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Sprinter 3500XD": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Sprinter 4500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "Toreto 45": ["2021", "2019"],
    "Toreto 48": ["2023", "2022", "2021", "2018", "2017", "2016"],
    "Torino": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Tres Ejes": ["2012"],
    "V220d": ["2020", "2019", "2018", "2017", "2016"],
    "V250": ["2020", "2019", "2018", "2017"],
    "Viaggio 1050": ["2020", "2019", "2018", "2017", "2016", "2015"],
    "Viaggio 900": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "Viale BRT": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "Viano": ["2015", "2014", "2013"],
    "Vito": ["2013", "2012", "2011", "2010", "2009"],
    "Zafiro 1040 GT": ["2023", "2022"],
    "eSprinter": ["2024"]
  },
  "Mercury": {
    "Bobcat": ["1980"],
    "Capri": ["1994", "1993", "1992", "1991", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979"],
    "Colony Park": ["1991", "1990", "1989", "1988", "1987", "1973"],
    "Comet": ["1977", "1976", "1975"],
    "Cougar": ["2002", "2001", "2000", "1999", "1997", "1996", "1995", "1994", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1982", "1981", "1980", "1978", "1977", "1976", "1975"],
    "Grand Marquis": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1982", "1981"],
    "Lynx": ["1987"],
    "Marauder": ["2004", "2003"],
    "Mariner": ["2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Marquis": ["1986", "1985", "1983", "1982", "1981", "1973"],
    "Milan": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "Monarch": ["1980", "1978", "1977", "1976", "1975"],
    "Montego": ["2007", "2006", "2005", "1976", "1975"],
    "Monterey": ["2007", "2006", "2005", "2004"],
    "Mountaineer": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Mystique": ["2000", "1999", "1998", "1997", "1996", "1995"],
    "Sable": ["2009", "2008", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Topaz": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Tracer": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1989", "1988", "1987"],
    "Zephyr": ["1983", "1982", "1981", "1980", "1979", "1978"]
  },
  "Merkur": {
    "XR4Ti": ["1987", "1986", "1985"]
  },
  "Mini": {
    "Cooper": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Cooper Clubman": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Cooper Countryman": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Cooper Paceman": ["2016", "2015", "2014", "2013"]
  },
  "Mitsubishi": {
    "3000GT": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "ASX": ["2015", "2014", "2013"],
    "Cordia": ["1988", "1987", "1986", "1985", "1984", "1983"],
    "Diamante": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Eclipse": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Eclipse Cross": ["2024", "2023", "2022", "2020", "2019", "2018"],
    "Endeavor": ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Expo": ["1995", "1994", "1993", "1992"],
    "Expo LRV": ["1994", "1993", "1992"],
    "Galant": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Grandis": ["2009", "2008", "2007"],
    "L200": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Lancer": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Mighty Max": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "Mirage": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Mirage G4": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Montero": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "Montero Sport": ["2021", "2020", "2019", "2018", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Outlander": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Outlander PHEV": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Outlander Sport": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Precis": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "RVR": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Raider": ["2009", "2008", "2007", "2006"],
    "Sigma": ["1990", "1989"],
    "Space Star": ["2004", "2003"],
    "Starion": ["1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "Tredia": ["1988", "1987", "1986", "1985", "1984", "1983"],
    "Van": ["1990", "1989", "1988", "1987"],
    "Xpander": ["2022"],
    "i-MiEV": ["2017", "2016", "2014", "2012"]
  },
  "Mobility Ventures": {
    "MV-1": ["2017", "2016", "2015"]
  },
  "Nissan": {
    "200SX": ["1998", "1997", "1996", "1995", "1988", "1987", "1986", "1985", "1984"],
    "240SX": ["1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "300ZX": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "350Z": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "370Z": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "720": ["1986", "1985", "1984", "1983"],
    "ARIYA": ["2025", "2024", "2023"],
    "Almera": ["2005", "2004", "2003", "2001"],
    "Altima": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Altra EV": ["2001", "2000", "1999"],
    "Aprio": ["2010", "2009", "2008"],
    "Armada": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Axxess": ["1995", "1994", "1993", "1992", "1991", "1990"],
    "Cabstar": ["2016", "2015", "2014", "2013", "2012", "2011", "2009", "2008"],
    "Cabstar E": ["2009", "2008"],
    "Cube": ["2014", "2013", "2012", "2011", "2010", "2009"],
    "D21": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Frontier": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "GT-R": ["2024", "2023", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Juke": ["2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Kicks": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "LEAF": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "March": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Maxima": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Micra": ["2019", "2018", "2017", "2016", "2015", "2007", "2006", "2005", "1991", "1990", "1988", "1987", "1985", "1984"],
    "Murano": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "NP300": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "NP300 Frontier": ["2020", "2019", "2018", "2017", "2016"],
    "NT400 Cabstar": ["2018", "2017"],
    "NV1500": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "NV200": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "NV2500": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "NV350 Urvan": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "NV3500": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "NX": ["1993", "1992", "1991"],
    "Note": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "Pathfinder": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Pathfinder Armada": ["2004"],
    "Pickup": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Platina": ["2010", "2009", "2008"],
    "Pulsar": ["1983"],
    "Pulsar NX": ["1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "Qashqai": ["2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Quest": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2009", "2008", "2007", "2006", "2005", "2004", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Rogue": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Rogue Select": ["2015", "2014"],
    "Rogue Sport": ["2022", "2021", "2020", "2019", "2018", "2017"],
    "Sentra": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Stanza": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "TITAN": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "TITAN XD": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Tiida": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Tsuru": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2005", "2003", "2002", "2001", "2000", "1999", "1997", "1996"],
    "Urvan": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "V-Drive": ["2022", "2021", "2020"],
    "Van": ["1988", "1987"],
    "Versa": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Versa Note": ["2019", "2018", "2017", "2016", "2015", "2014"],
    "X-Trail": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "Xterra": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Z": ["2025", "2024", "2023"]
  },
  "Oldsmobile": {
    "442": ["1971", "1970", "1969", "1968", "1967", "1966"],
    "88": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "98": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Achieva": ["1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Alero": ["2004", "2003", "2002", "2001", "2000", "1999"],
    "Aurora": ["2003", "2002", "2001", "1999", "1998", "1997", "1996", "1995"],
    "Bravada": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1994", "1993", "1992"],
    "Calais": ["1987", "1986", "1985"],
    "Custom Cruiser": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Cutlass": ["1999", "1998", "1997", "1988", "1987", "1986", "1985", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Cutlass Calais": ["1991", "1990", "1989", "1988", "1984", "1983"],
    "Cutlass Ciera": ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "Cutlass Cruiser": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Cutlass Salon": ["1987", "1986", "1985"],
    "Cutlass Supreme": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "Delta 88": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1979", "1978", "1977", "1975", "1974"],
    "Firenza": ["1987", "1986", "1985", "1984"],
    "Intrigue": ["2002", "2001", "2000", "1999", "1998"],
    "LSS": ["1999", "1998", "1997", "1996"],
    "Regency": ["1998", "1997"],
    "Silhouette": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Toronado": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"]
  },
  "Panoz": {
    "AIV Roadster": ["2000", "1999"],
    "Esperante": ["2006", "2005", "2004"]
  },
  "Plymouth": {
    "Acclaim": ["1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Breeze": ["2000", "1999", "1998", "1997", "1996"],
    "Caravelle": ["1988", "1987", "1986", "1985"],
    "Colt": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Conquest": ["1986", "1985"],
    "Expo": ["1989", "1988", "1987"],
    "Grand Voyager": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
    "Horizon": ["1987", "1986", "1985", "1984", "1983"],
    "Laser": ["1994", "1993", "1992", "1991", "1990"],
    "Neon": ["2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Prowler": ["2001", "2000", "1999", "1997"],
    "Reliant": ["1989", "1988", "1987", "1986", "1985"],
    "Sundance": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "Turismo": ["1985", "1983"],
    "Voyager": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"]
  },
  "Pontiac": {
    "6000": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "Aztek": ["2005", "2004", "2003", "2002", "2001"],
    "Bonneville": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1970"],
    "Fiero": ["1988", "1987", "1986", "1985", "1984"],
    "Firebird": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974"],
    "Firefly": ["2000", "1999", "1998", "1997", "1996", "1995", "1994", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "G3": ["2010", "2009"],
    "G3 Wave": ["2009"],
    "G5": ["2010", "2009", "2008", "2007"],
    "G6": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "G8": ["2009", "2008"],
    "GTO": ["2006", "2005", "2004"],
    "Grand Am": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Grand Prix": ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "Grandville": ["1975"],
    "J2000": ["1983", "1982"],
    "J2000 Sunbird": ["1985", "1984"],
    "LeMans": ["1990", "1977"],
    "Montana": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Parisienne": ["1986", "1985", "1984"],
    "Pursuit": ["2006", "2005"],
    "Safari": ["1989", "1988", "1987"],
    "Solstice": ["2009", "2008", "2007", "2006"],
    "Sunbird": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "Sunfire": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Torrent": ["2009", "2008", "2007", "2006"],
    "Trans Sport": ["1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Vibe": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Wave": ["2008", "2007", "2006", "2005"],
    "Wave5": ["2007", "2006", "2005"]
  },
  "Porsche": {
    "718 Boxster": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "718 Cayman": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "718 Spyder": ["2023", "2022", "2021", "2020"],
    "911": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "912": ["1976"],
    "918 Spyder": ["2015"],
    "924": ["1988", "1987", "1982", "1981", "1980", "1979", "1978", "1977"],
    "928": ["1995", "1994", "1993", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "930": ["1979", "1978"],
    "944": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "968": ["1995", "1994", "1993", "1992"],
    "Boxster": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Carrera GT": ["2006", "2005", "2004"],
    "Cayenne": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004", "2003"],
    "Cayman": ["2016", "2015", "2014", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Macan": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Panamera": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Taycan": ["2023", "2022", "2021", "2020"]
  },
  "Ram": {
    "1500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "1500 Classic": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "2500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "3500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "4000": ["2020", "2019", "2018", "2017"],
    "4500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "5500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "C/V": ["2015", "2014", "2013", "2012"],
    "Dakota": ["2011"],
    "ProMaster 1500": ["2025", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "ProMaster 2500": ["2025", "2024", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "ProMaster 3500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "ProMaster City": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"]
  },
  "SRT": {
    "Viper": ["2014", "2013"]
  },
  "Saab": {
    "9-3": ["2003", "2002", "2001", "2000", "1999"],
    "9-4X": ["2011"],
    "9-5": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "9-7x": ["2009", "2008", "2007", "2006", "2005"],
    "900": ["1998", "1997", "1996", "1994", "1991", "1988"],
    "9000": ["1994", "1993", "1992", "1991", "1990", "1989"]
  },
  "Saturn": {
    "Astra": ["2009", "2008"],
    "Aura": ["2009", "2008", "2007"],
    "Ion": ["2007", "2006", "2005", "2004", "2003"],
    "L100": ["2002", "2001"],
    "L200": ["2003", "2002", "2001"],
    "L300": ["2005", "2004", "2003", "2002", "2001"],
    "LS": ["2000"],
    "LS1": ["2000"],
    "LS2": ["2000"],
    "LW1": ["2000"],
    "LW2": ["2000"],
    "LW200": ["2003", "2002", "2001"],
    "LW300": ["2003", "2002", "2001"],
    "Outlook": ["2010", "2009", "2008", "2007"],
    "Relay": ["2007", "2006", "2005"],
    "SC": ["1992", "1991"],
    "SC1": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "SC2": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "SL": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "SL1": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "SL2": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "SW1": ["1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "SW2": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Sky": ["2010", "2009", "2008", "2007"],
    "Vue": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"]
  },
  "Scion": {
    "FR-S": ["2016", "2015", "2014", "2013"],
    "iA": ["2016"],
    "iM": ["2016"],
    "iQ": ["2015", "2014", "2013", "2012"],
    "tC": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "xA": ["2006", "2005", "2004"],
    "xB": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004"],
    "xD": ["2014", "2013", "2012", "2011", "2010", "2009", "2008"]
  },
  "Seat": {
    "Altea": ["2010", "2006", "2005"],
    "Altea XL": ["2010", "2008"],
    "Ateca": ["2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Leon": ["2020", "2019", "2018", "2017", "2016", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Tarraco": ["2022", "2021", "2020", "2019"],
    "Toledo": ["2006"]
  },
  "Smart": {
    "Fortwo": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"]
  },
  "Sterling": {
    "825": ["1988", "1987"],
    "827": ["1991", "1990", "1989"]
  },
  "Subaru": {
    "B9 Tribeca": ["2007", "2006"],
    "BRZ": ["2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    "Baja": ["2006", "2005", "2004"],
    "Crosstrek": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Forester": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "Impreza": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Justy": ["1994", "1993", "1992", "1991", "1990", "1989"],
    "Legacy": ["2018", "2017", "2016", "2015", "2013", "2009", "2008", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Outback": ["2019", "2018", "2017", "2016", "2015", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "WRX": ["2020", "2019", "2015", "2014", "2013", "2012"],
    "WRX STI": ["2020", "2019"],
    "XV Crosstrek": ["2015", "2014", "2013"]
  },
  "Suzuki": {
    "Aerio": ["2007", "2006", "2005", "2004", "2003", "2002"],
    "Equator": ["2012", "2011", "2010", "2009"],
    "Esteem": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Forsa": ["1988", "1987", "1986"],
    "Grand Vitara": ["2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "SA310": ["1985"],
    "SJ410": ["1985", "1984", "1983", "1982", "1981", "1980"],
    "SJ413": ["1985"],
    "SX4": ["2009", "2008", "2007"],
    "Samurai": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Sidekick": ["1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Swift": ["1997", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Swift+": ["2007", "2006", "2005", "2004"],
    "Vitara": ["2004", "2003", "2002", "2001", "2000", "1999"],
    "X-90": ["1998", "1997", "1996"],
    "XL-7": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"]
  },
  "Toyota": {
    "4Runner": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "86": ["2020", "2019", "2018", "2017"],
    "Avalon": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Avanza": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "C-HR": ["2022", "2021", "2020", "2019", "2018"],
    "Camry": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
    "Celica": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "Corolla": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "Corolla Cross": ["2025", "2024", "2023", "2022"],
    "Corolla iM": ["2018", "2017"],
    "Corona": ["1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Cressida": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978"],
    "Crown": ["2025", "2024", "2023"],
    "Crown Signia": ["2025"],
    "Echo": ["2005", "2004", "2003", "2002", "2001", "2000"],
    "FJ Cruiser": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "GR Corolla": ["2025", "2024", "2023"],
    "GR Supra": ["2024", "2023", "2022", "2021", "2020"],
    "GR86": ["2024", "2023", "2022"],
    "Grand Highlander": ["2025", "2024"],
    "Hiace": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Highlander": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Hilux": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Land Cruiser": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "MR2": ["1995", "1994", "1993", "1992", "1991", "1989", "1988", "1987", "1986", "1985"],
    "MR2 Spyder": ["2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Matrix": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Mirai": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Paseo": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Pickup": ["1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Previa": ["1997", "1996", "1995", "1994", "1993", "1992", "1991"],
    "Prius": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Prius AWD-e": ["2022", "2021", "2020", "2019"],
    "Prius C": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Prius Plug-In": ["2015", "2014", "2013", "2012"],
    "Prius Prime": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Prius V": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "RAV4": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "RAV4 Prime": ["2024", "2023", "2022", "2021"],
    "Rush": ["2009"],
    "Sequoia": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "Sienna": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "Solara": ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Starlet": ["1984", "1983"],
    "Supra": ["2022", "2021", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
    "T100": ["1998", "1997", "1996", "1995", "1994", "1993"],
    "Tacoma": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Tercel": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980"],
    "Tundra": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "Van": ["1989", "1988", "1987", "1986", "1985", "1984"],
    "Venza": ["2024", "2023", "2022", "2021", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Yaris": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Yaris R": ["2020", "2019", "2018", "2017", "2016"],
    "Yaris iA": ["2018", "2017"],
    "bZ4X": ["2025", "2024", "2023"]
  },
  "VPG": {
    "MV-1": ["2012"]
  },
  "Volkswagen": {
    "Amarok": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Arteon": ["2023", "2022", "2021", "2020", "2019"],
    "Atlantic": ["1987", "1986", "1985", "1984", "1983", "1982", "1981"],
    "Atlas": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Atlas Cross Sport": ["2024", "2023", "2022", "2021", "2020"],
    "Beetle": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1979", "1978", "1977", "1976", "1975"],
    "Beetle Cabrio": ["2011", "2010"],
    "Bora": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Brasilia": ["1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974"],
    "CC": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Cabrio": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Cabriolet": ["1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Caddy": ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Caravelle": ["1996"],
    "Caribe": ["1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
    "Clasico": ["2015", "2014", "2013", "2012", "2011"],
    "Combi": ["2014", "2001", "2000", "1999", "1998", "1997", "1996", "1994", "1993", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972"],
    "Constellation": ["2020", "2019", "2018", "2017", "2016", "2015"],
    "Corrado": ["1995", "1994", "1993", "1992", "1991", "1990"],
    "Corsar": ["1988", "1987", "1986", "1985"],
    "Crafter": ["2018", "2017", "2016"],
    "Crafter Van": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "CrossFox": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2009", "2008", "2007"],
    "Dasher": ["1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Delivery": ["2020", "2019", "2018", "2017", "2016", "2015"],
    "Derby": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
    "Eos": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "EuroVan": ["2009", "2008", "2007", "2006", "2004", "2003", "2002", "2001", "2000", "1999", "1997", "1996", "1995", "1994", "1993", "1992"],
    "Fox": ["1993", "1992", "1991", "1990", "1989", "1988", "1987"],
    "GLI": ["2010"],
    "GTI": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Gol": ["2020", "2019", "2018", "2017", "2016", "2013", "2012"],
    "Gol Sedan": ["2013", "2012", "2011", "2010"],
    "Golf": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "Golf Alltrack": ["2019", "2018", "2017"],
    "Golf City": ["2010", "2009", "2008", "2007"],
    "Golf R": ["2024", "2023", "2022", "2019", "2018", "2017", "2016", "2015", "2013", "2012"],
    "Golf SportWagen": ["2019", "2018", "2017", "2016", "2015", "2013", "2012", "2011", "2010"],
    "Hormiga": ["1978", "1977"],
    "ID. Buzz": ["2025"],
    "ID.4": ["2025", "2024", "2023", "2022", "2021"],
    "Jetta": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980"],
    "Jetta City": ["2009", "2008", "2007"],
    "Lupo": ["2009", "2008", "2007", "2006", "2005"],
    "Multivan": ["2013"],
    "Nuevo Gol": ["2016", "2015", "2014"],
    "Panel": ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Passat": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "Passat CC": ["2012", "2011", "2010", "2009"],
    "Phaeton": ["2006", "2005", "2004"],
    "Pointer": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Pointer Truck": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "Polo": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2007", "2006", "2005", "2004", "2003"],
    "Quantum": ["1988", "1987", "1986", "1985", "1984", "1983", "1982"],
    "R32": ["2008", "2004", "2003"],
    "Rabbit": ["2009", "2008", "2007", "2006", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Rabbit Convertible": ["1984", "1983", "1982", "1981", "1980"],
    "Rabbit Pickup": ["1983", "1982", "1981", "1980"],
    "Robust": ["2020"],
    "Routan": ["2014", "2013", "2012", "2011", "2010", "2009"],
    "Safari": ["1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971"],
    "Saveiro": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Scirocco": ["1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975"],
    "Sedan": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964", "1963", "1962", "1961"],
    "Sharan": ["2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    "SportVan": ["2010", "2009", "2008", "2007"],
    "Super Beetle": ["1980", "1979", "1978", "1977", "1976", "1975", "1974"],
    "T-Cross": ["2021", "2020"],
    "Taos": ["2025", "2024", "2023", "2022", "2021"],
    "Teramont": ["2021", "2019"],
    "Tiguan": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Tiguan Limited": ["2018", "2017"],
    "Touareg": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Transporter": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1979", "1978", "1977", "1976", "1975"],
    "Up!": ["2018", "2017", "2016"],
    "Van": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Vanagon": ["1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980"],
    "Vento": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Virtus": ["2022", "2021", "2020"],
    "Volksbus": ["2020", "2019", "2018", "2017", "2016", "2015"],
    "Worker": ["2017", "2016", "2015"],
    "Workline": ["2020", "2019", "2018"],
    "e-Golf": ["2020", "2019", "2018", "2017", "2016", "2015"]
  },
  "Volvo": {
    "240": ["1993", "1992", "1991", "1990"],
    "242": ["1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "244": ["1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "245": ["1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976"],
    "740": ["1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985"],
    "745": ["1985"],
    "760": ["1990", "1989", "1988", "1987", "1986", "1985", "1984"],
    "780": ["1991", "1990", "1989"],
    "940": ["1995", "1994", "1993", "1992", "1991"],
    "S60": ["2018", "2014", "2013", "2012"],
    "S80": ["2013", "2012"],
    "V60": ["2016", "2014"],
    "XC60": ["2021", "2020", "2019", "2018", "2013", "2012", "2011", "2010"],
    "XC70": ["2004"],
    "XC90": ["2006"]
  },
  "Western Star": {
    "4900SA": ["2002"]
  }
}
